/**
 * Build route with highlight query parameter
 * @param {string} route - Base route path
 * @param {string | null} selector - CSS selector to highlight
 * @returns {string} Route with optional highlight query param
 */
export const buildRouteWithHighlight = (route, selector) => {
  if (!selector) {
    return route;
  }
  const separator = route.includes('?') ? '&' : '?';
  return `${route}${separator}shippy-highlight=${encodeURIComponent(selector)}`;
};
